import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LinkService } from '../../services/link.service';
// import { AggregationService } from '../../services/aggregation.service';
import { CookieService } from 'ngx-cookie-service';
import { PznService } from "../../services/pzn.service";
import { JsInterstitialService } from '../../services/js-interstitial.service';
import { SessionStorageService } from '../../services/web-storage/session-storage.service';
import { RetirementService } from "../../services/retirement.service";
import { GenericService } from "../../services/generic.service";
import { first } from 'rxjs/operators';
import { PruHttpService } from "../../services/pru-http.service";

declare var environment: any;
@Component({
  selector: "link-banner",
  templateUrl: "./link-banner.component.html",
  styleUrls: ["./link-banner.component.scss"]
})
export class LinkBannerComponent implements OnInit {
  @Input() rspar: boolean = false;
  serviceUrl: string;
  data: any;
  linkcta: any;
  gid: number;
  staticAsset: string;
  linkUrl: string;
  SCHEDULE_CALL: string;
  showLinkBanner: boolean = false;
  suppressLinkBanner: boolean = true;
  CT_GOAL: string = "/wps/wcm/myconnect/ucd_content/sa-link/link-goals";
  CT_NO_GOAL = "/wps/wcm/myconnect/ucd_content/sa-link/link-no-goal";
  ct_banner: any;
  dems: boolean = false;

  constructor(
    // private _aggregationService: AggregationService,
    public _cookieService: CookieService,
    private _genericService: GenericService,
    private _linkService: LinkService,
    private _pznService: PznService,
    private _sessionStorageService: SessionStorageService,
    private _jsInterstitialService: JsInterstitialService,
    private _retirementService: RetirementService,
    private _pruHttpService: PruHttpService
  ) { }

  ngOnInit() {
    
    let globalsessionid = this._cookieService.get('X-PruGlobalSessionID');
    this.gid = parseInt(globalsessionid ? globalsessionid.substring(globalsessionid.length - 1, globalsessionid.length) : '0');
    this.staticAsset = environment.STATIC_ASSETS;
    this.linkUrl = environment.LINK_URL;
    this.SCHEDULE_CALL = environment.SCHEDULE_CALL;

    this._linkService.linkEvent.pipe(first()).subscribe(linkGoals => {
      /* this._genericService.toggleFeatures$.subscribe((res: any) => {
        this.dems = res.includes(environment.MKT_FEATURE_DEMS);
        this._genericService.showDems = this.dems;
      }); */
      this.dems = this._genericService.showDems;
      this.doBannerCheck(linkGoals);
    });
  }

  doBannerCheck(linkGoals) {
    // Added subscription to make sure check for retirement balance is done before getting retirement value
    if (this._genericService.usr_rspar) {
      this._retirementService.retirementObs.subscribe(retirementData => {
        this.suppressLinkBanner = !this._retirementService.hasRetirementBalance();
      });
    } else {
      this.suppressLinkBanner = false;
    }

    if (linkGoals === "hasGoals") {
      this.getWcmCnt(true);
    } else {
      let linkcta = this._sessionStorageService.getItem("linkCTA", true);
      if (linkcta && linkcta.length > 0) {
        if (this._genericService.usr_rspar) {
          this._jsInterstitialService.linkInterstitial$.subscribe(
            linkInterstitial => {
              if (!linkInterstitial) {
                this.linkcta = linkcta[0];
                this.getWcmCnt(false);
              }
            }
          );
        } else {
          this.linkcta = linkcta[0];
          this.getWcmCnt(false);
        }
      } else {
        this._pznService.linkCTAObs$.subscribe(linkCTAData => {
          if (linkCTAData && linkCTAData.length > 0) {
            if (this._genericService.usr_rspar) {
              this._jsInterstitialService.linkInterstitial$.subscribe(
                linkInterstitial => {
                  if (!linkInterstitial) {
                    this.linkcta = linkCTAData[0];
                    this.getWcmCnt(false);
                  }
                }
              );
            } else {
              this.linkcta = linkCTAData[0];
              this.getWcmCnt(false);
            }
          }
        });
      }
    }
  }

  getWcmCnt(goals: boolean) {
    let choice = this.gid % 2 > 0 ? "-A" : "-B";
    this.serviceUrl = goals ? this.CT_GOAL + choice : this.CT_NO_GOAL + choice;
    this._pruHttpService.getText(this.serviceUrl, "wcm-link").subscribe(data => {
      this.ct_banner = data;
      this.showLinkBanner = true;
    });
  }
}
